//@flow

import {makeStyles, MenuItem} from '@material-ui/core';
import React from 'react';
import CustomSelect from '../../../../elements/CustomSelect/CustomSelect';
import {useProductFilter} from '../../utils/productFilters';
import CategoryFilter from './CategoryFilter';
import PromotionFilter from './PromotionFilter';
import StockFilter from './StockFilter';
import WholesalePriceFilter from './WholesalePriceFilter';

const useStyles = makeStyles(theme => ({
  filters: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: '1.5rem 1rem',
    [theme.breakpoints.up('md')]: {
      flexWrap: 'nowrap',
    },
  },
  options: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('md')]: {
      flex: 0,
    },
  },
}));

export default function ProductFilter() {
  const classes = useStyles();

  const {filter, setFilter} = useProductFilter();

  return (
    <div className={classes.filters}>
      <div className={classes.options}>
        <span>Filtrar por </span>
        <CustomSelect
          pagination
          disableUnderline
          className={classes.sizeSelect}
          defaultValue={filter.type}
          onChange={e => {
            const filterType = e.target.value;
            setFilter(filterType);
          }}
        >
          <MenuItem value="category">Categoría</MenuItem>
          <MenuItem value="promotions">Promociones</MenuItem>
          <MenuItem value="wholesale-price">Precio Mayorista</MenuItem>
          <MenuItem value="stock">Stocks</MenuItem>
        </CustomSelect>
      </div>

      {filter.type === 'category' && <CategoryFilter />}
      {filter.type === 'promotions' && <PromotionFilter />}
      {filter.type === 'wholesale-price' && <WholesalePriceFilter />}
      {filter.type === 'stock' && <StockFilter />}
    </div>
  );
}
